<template>
  <div>
    <section class="white">
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="6"
            style="display: flex; align-items: center"
          >
<!--            <h2-->
<!--              :class="[$vuetify.breakpoint.mdAndUp ? 'display-1' : 'headline']"-->
<!--              class="mb-4"-->
<!--            >-->
<!--              {{ $t('team.title') }}-->
<!--            </h2>-->

            <p class="subtitle-1">
              {{ $t('team.paragraph1') }}
            </p>
<!--            <p class="mb-5">-->
<!--              {{ $t('team.paragraph2') }}-->
<!--            </p>-->

            <!-- <v-btn
              outlined
              color="primary"
              class="px-5"
              large
            >
              Hire Me
            </v-btn> -->
          </v-col>
          <v-col
            cols="12"
            md="5"
            offset-md="1"
          >
            <v-card>
              <v-img src="/static/romain-v-nMDp15T4lJ0-unsplash.jpg" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section class="grey lighten-3">
      <v-container>
        <v-row
          justify="center"
          align="center"
        >
          <v-col
            cols="12"
            class="text-center"
          >
            <h1 class="display-2">
              {{ $t('team.team_section_title') }}
            </h1>
          </v-col>

          <team-member
            v-for="(member, index) in team"
            :key="member.name + index"
            :member="member"
          />
        </v-row>
      </v-container>
    </section>

<!--    <section class="white">-->
<!--      <v-container>-->
<!--        <v-row>-->
<!--          <v-col-->
<!--            v-for="([icon, number, name], i) in experiences"-->
<!--            :key="i"-->
<!--            cols="6"-->
<!--            md="3"-->
<!--          >-->
<!--            <div class="text-center">-->
<!--              <v-icon-->
<!--                size="64"-->
<!--                class="mb-3"-->
<!--                v-text="icon"-->
<!--              />-->
<!--              <div-->
<!--                class="display-2 font-weight-bold mb-2"-->
<!--                v-text="number"-->
<!--              />-->
<!--              <div-->
<!--                class="text-uppercase"-->
<!--                v-text="name"-->
<!--              />-->
<!--            </div>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </v-container>-->
<!--    </section>-->
  </div>
</template>

<script>
  export default {
    components: {
      TeamMember: () => import('@/components/TeamMember')
    },
    data: () => ({
      highlights: [
        'Element 1',
        'Element 2',
        'Element 3',
        'Element 4',
        'Element 5',
        'Element 6'
      ],
      experiences: [
        ['mdi-vuejs', '75', 'Sed ut perspiciatis unde omnis'],
        ['mdi-vuetify', '100', 'Sed ut perspiciatis unde omnis'],
        ['mdi-aws', '67', 'Sed ut perspiciatis unde omnis'],
        ['mdi-server-security', '95', 'Sed ut perspiciatis unde omnis']
      ],
      team: [
        {
          name: 'Julio Gamboa Cornu',
          level: 'team.member1_level',
          img: '/static/Julio2.png',
          shortDescription: 'team.member1_short_description',
          description: 'team.member1_description'
        },
        {
          name: 'Felipe Gamboa Lavados',
          level: 'team.member2_level',
          img: '/static/Felipe1.png',
          shortDescription: 'team.member2_short_description',
          description: 'team.member2_description'
        }
      ]
    }),
    methods: {
      showOverlay () {
        console.log('test!')
      }
    }
  }
</script>
